import { useEffect, useState } from "react";
import Btn from "../components/common/Btn";
import Search from "../components/common/Search";
import Table from "../components/common/Table";
import { noticeTheadArr } from "../constants/TheadConst";
import { CommmonBoxLayout, CommonBoxTitle, CommonFooter, CommonLayout, FlexColBetweenBox, SearchBox, TableLayout, TitleTd, TrPointer } from "../style/common";
import { gnbConst } from "../constants/gnbConst";
import { useNavigatePage } from "../hooks/useNavigatePage";
import Paging from "../components/common/paging";
import { contentsList } from "../api/contents";
import { Spinner } from "../components/common/Spinner";
import { dateHyphen } from "../utils/dateFormChange";
import { useMemberStore } from "../store/memberStore";

export default function Notice() {
  const { onMovementPage } = useNavigatePage();
  const { memberPermitLevel } = useMemberStore();
  const pageTitle = gnbConst[2].title;
  const titleWit = noticeTheadArr.filter(obj => obj.key === "title")[0].width;
  const [searchVal, setSearchVal] = useState("");
  const [pagingVal, setPagingVal] = useState(1);
  const [noticeListData, setNoticeListData] = useState<ListGetApiResponse>();

  const getNoticeList = async () => {
    try {
      const params = {
        page_index: pagingVal,
        page_size: 10,
        search_field: "title",
        search: searchVal,
      }
      const respones = await contentsList(params, "notice");
      setNoticeListData(respones);
    } catch (error) {}
  } 

  const onPageChange = (page: number) => {
    setPagingVal(page);
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => { 
    const {
        target: { name, value },
    } = e;
    
    if (name === "search") {
      setSearchVal(value);
    } 
  };

  useEffect(() => {
    if (searchVal) setPagingVal(1);
    getNoticeList();
  }, [searchVal, pagingVal]);

  return (
    <CommonLayout>
      <CommmonBoxLayout>
        <FlexColBetweenBox>
          <div>
            <CommonBoxTitle>{pageTitle}</CommonBoxTitle>

            <SearchBox>
              <Search value={searchVal} onChange={onSearchChange} placeholder="제목 검색" />
              {memberPermitLevel >= 100 && (
                <Btn type="button" title="글쓰기" color="skyBlue" size="lg" onClick={() => onMovementPage("/notice/detail/add")} /> 
              )}
            </SearchBox>

            {noticeListData ? (
              <TableLayout>
                <Table thead={noticeTheadArr}>
                  {noticeListData.list.length > 0 && noticeListData.list.map((obj, i) => (
                    <TrPointer key={i} onClick={() => onMovementPage("/notice/detail/" + obj.idx)}>
                      {/* <td><input type="checkbox" /></td> */}
                      <td>
                        {noticeListData.page && (
                          noticeListData.page.page_index && (
                            (noticeListData.page.page_index - 1) * 10 + i + 1
                          )
                        )}
                      </td>
                      <TitleTd $titleWit={titleWit}>{obj.title ? obj.title : "-"}</TitleTd>
                      <td>{obj.member?.member_name ? obj.member.member_name : "-"}</td>
                      <td>{obj.date_active ? dateHyphen(obj.date_active, "YYYY-MM-DD") : "-"}</td>
                      <td>{obj.count_read ? obj.count_read : 0}</td>
                    </TrPointer>
                  ))}
                </Table>

                <Paging
                  pageIndex={pagingVal}
                  totalPage={noticeListData.page?.total_page ? noticeListData.page.total_page : 0}
                  onPageChange={onPageChange}
                />
              </TableLayout>
            ) : <Spinner />}
          </div>

          <CommonFooter>
            <div></div>
            {memberPermitLevel >= 100 && (
              <Btn type="button" title="글쓰기" color="skyBlue" size="lg" onClick={() => onMovementPage("/notice/detail/add")} /> 
            )}
          </CommonFooter>
        </FlexColBetweenBox>
      </CommmonBoxLayout>
    </CommonLayout>
  );
}